module.exports = __webpack_public_path__ + "img/102040.1607a3f9.png";